//import Fetching from '@/services/FetchData';
let getApi = () => import('@/services/Api');

const state = {
    //спиок таблиц
    all: sessionStorage.getItem('allCatalogs') ? JSON.parse(sessionStorage.getItem('allCatalogs')) : [],
    refs: [],//ссылочные данные при заполнении формы
    currentTab: '',//текущая таблица
    tabHeadersAll: [],
};

// getters
const getters = {
    getStoredTableContent: (state) => (table) => state.refs.find(item => item.table.toUpperCase() === table.toUpperCase()),
    getCurrentTableName: (state) => state.currentTab,

    getAllCatalogs: (state) => state.all,
    getAllTablesHeader: (state) => state.tabHeadersAll,
    getCurrentTableName1: (state, getters) => {
        let tab = state.all.find(item => item.code === state.currentTab)
        return (tab && tab.name) ? tab.name[getters.getChosenLang] : null;
    },
    getCurrentTableHeader: (state) => {
        let header = state.tabHeadersAll.find(headers => headers.table === state.currentTab);
        //Убрал из таблиц столбцы с типом ARR, задача в Trello
        let headerFiltered = header? header.content.filter(headers => headers.type !== "ARR"): [];
        return (headerFiltered)? headerFiltered : (header) ? header.content : [];
    },
    getTableHeaderByName: (state) => (table) => {
        let header = state.tabHeadersAll.find(headers => headers.table === table);
        return (header) ? header.content : [];
    },

}

// actions
const actions = {

    async storeCatalogs({commit, getters}) {

        try {
            let {http} = await getApi();
            const response = await http.getData('dicts', {
                lng: getters.getChosenLang
            });
            if (response && response.data) {
                commit('setCatalogs', response.data)
            }
        } catch (err) {
            commit('setError', err.toString())
        }


    },
    async storeTableContent({commit, getters}, payload) {
        const response = getters.getStoredTableContent(payload.table);
        let content = (response) ? response.content : [];
        if (!content || content.length === 0 || response.totalCount > 50 ) {
            try {
                let {http} = await getApi();
                const response = await http.getData('/dependency/' + payload.table, {
                    lang: getters.getChosenLang,
                    search: payload.search,
                    rowsPerPage:payload.rowsPerPage,
                    page:payload.page,
                    selectedId:payload.selectedId,
                    sortBy: payload.sortBy,
                    descending: payload.descending,
                });
                if (response && response.data && response.data.tabRows) {
                    let obj = {table: payload.table, content: response.data.tabRows};
                    if (!payload.search) obj.totalCount = response.data.totalRows;
                    content = response.data.tabRows;
                    commit('setStoredTableContent', obj)
                }
            } catch (err) {
                commit('setError', err.toString())
            }
        }
        return JSON.parse(JSON.stringify(content));
    },
    async storeTabHeader({commit, getters}, payload) {
        let table = (payload && payload.table) ? payload.table : getters.getCurrentTableName;
        if (!table) return;

        let headers = getters.getAllTablesHeader.find(headers => headers.table === table);
        if (headers) {
            return headers.content;
        } else {

            let {http} = await getApi();
            const response = await http.getData(`/header/${table}`, {
                tabName: table,
                lng: getters.getChosenLang
            });
            if (response && response.data) {
                //commit('setTabHeadersAll', response.data.tabheader);
                commit('setTabHeadersAll', {content: response.data.tabheader, table: table});
                return response.data.tabheader
            }
        }
    },
    storeCurrentTableName({commit}, item) {
        commit('setTableName', item)
    },

};

// mutations
const mutations = {

    setCatalogs(state, catalogs) {
        state.all = catalogs;
        sessionStorage.removeItem('allCatalogs');
        sessionStorage.setItem('allCatalogs', JSON.stringify(catalogs))
    },
    setStoredTableContent(state, item) {
        state.refs.push(item)
    },
    setTabHeadersAll(state, item) {
        state.tabHeadersAll.push(item)
        state.tabHeadersAll = [...state.tabHeadersAll]

    },
    setTableName(state, item) {
        state.currentTab = item;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}